// import { ODTCreditCardType } from '@rockefeller-center/api-client-odt';

// export const VALID_PROCESSING_FEE_TICKET_IDS = ['137', '139'];

// export const PROCESSING_FEE_TICKET_IDS: { [key in Flow]?: string } = {
//   [Flow.TOUR]: '139',
//   [Flow.VIP]: '137',
//   [Flow.ROCK_PASS]: '137',
//   [Flow.EXPRESS_PASS]: '137',
//   [Flow.DECK]: '137',
// };

export const SUNSET_ADD_ON_PRICE = 1500;

export const CreditCardDisplayNames = {
  // [ODTCreditCardType.Unknown]: 'Unknown',
  // [ODTCreditCardType.Visa]: 'Visa',
  // [ODTCreditCardType.MasterCard]: 'MasterCard',
  // [ODTCreditCardType.AmericanExpress]: 'American Express',
  // [ODTCreditCardType.Discover]: 'Discover',
  // [ODTCreditCardType.DinersClub]: "Diner's Club",
};

export const RefundErrorMessages = [
  {
    reason: 1,
    message: 'barcode_refund_error',
    // message: 'Barcode not found'
  },
  {
    reason: 2,
    message: 'cardholder_refund_error',
    // message: 'Cardholder details do not match'
  },
  {
    reason: 3,
    message: 'sale_expired_refund_error',
    // message: 'Sale has expired',
  },
  {
    reason: 4,
    message: 'sale_refunded_refund_error',
    //  message: 'Sale has been refunded'
  },
  {
    reason: 5,
    message: 'sale_reissued_refund_error',
    // message: 'Sale has been reissued'
  },
  {
    reason: 6,
    message: 'sale_cancelled_refund_error',
    // message: 'Sale has been cancelled'
  },
  {
    reason: 7,
    message: 'tickets_used_refund_error',
    //  message: 'Tickets have been used'
  },
  {
    reason: 8,
    message: 'timeslot_refund_error',
    // message: 'Timeslot is too near'
  },
  {
    reason: 9,
    message: 'no_valid_refund_error',
    // message: 'No valid tickets'
  },
  {
    reason: 10,
    message: 'exclusive_sale_refund_error',
    // message: 'Sale Is Exclusive'
  },
  {
    reason: 11,
    message: 'citypass_booklet_refund_error',
    // message: 'CityPass Booklet Sale'
  },
  {
    reason: 12,
    message: 'contains_citypass_refund_error',
    // message: 'Sale contains CityPass Tickets'
  },
];

export const standardError = {
  message:
    'We are experiencing technical difficulties and online ticket purchasing is currently unavailable. Please try again later today, visit our Box Office located on 50th Street between 5th and 6th Avenues, or call Customer Service at (212) 698-2000.',
  name: 'Oh, no!',
};

export const PaymentErrorMessages = [
  {
    reason: 2,
    message: 'declined_payment_error',
    // message: 'Declined (Gateway).'
  },
  {
    reason: 3,
    message: 'failed_payment_error',
    // message: 'Failed (Gateway).'
  },
  {
    reason: 4,
    message: 'timeout_payment_error',
    // message: 'Sale duration timeout expired.'
  },
  {
    reason: 5,
    message: 'payment_processed_payment_error',
    // message: 'Payment already processed.'
  },
  {
    reason: 6,
    message: 'invalid_sale_payment_error',
    // message: 'Invalid sale state.'
  },
  {
    reason: 7,
    message: 'exceeded_purchasing_payment_error',
    // message: 'Guest has exceeded their purchasing capacity for the period.',
  },
  {
    reason: 8,
    message: 'gateway_unavailable_payment_error',
    // message: 'Payment gateway is unavailable.'
  },
  {
    reason: 9,
    message: 'citypass_api_offline_payment_error',
    //  message: 'CityPass API Offline.'
  },
  {
    reason: 10,
    message: 'citypass_order_failure_payment_error',
    // message: 'CityPass Order Failure.'
  },
];

export const GenericErrorMessages = [
  {
    code: 400,
    title: '400_generic_error_title',
    message: '400_generic_error',
    // title: 'Bad Request',
    // message:
    //   'The server cannot process the payment due to a formatting error, please contact the RC support team with a description of what happened',
  },
  {
    code: 403,
    title: '403_generic_error_title',
    message: '403_generic_error',
    // title: 'Forbidden',
    // message:
    //   'The server has denied you the ability to process your payment, please contact the RC support team with a description of what happened',
  },
  {
    code: 404,
    title: '404_generic_error_title',
    message: '404_generic_error',
    // title: 'Not Found',
    // message:
    //   'The server could not find this resource, either due to an engineering bug or you have been denied this action, please contact the RC support team with a description of what happened',
  },
  {
    code: 408,
    title: '408_generic_error_title',
    message: '408_generic_error',
    // title: 'Request Timeout',
    // message:
    //   'A request took too long to be processed by the server, check your internet connection and try again',
  },
  {
    code: 429,
    title: '429_generic_error_title',
    message: '429_generic_error',
    // title: 'Too Many Requests',
    // message: 'You have made too many requests to the server, please try again',
  },
  {
    code: 500,
    title: '500_generic_error_title',
    message: '500_generic_error',
    // title: 'Internal Server Error',
    // message:
    //   'The server has encountered an error, our engineers are working on this, please try again later',
  },
  {
    code: 502,
    title: '502_generic_error_title',
    message: '502_generic_error',
    // title: 'Bad Gateway',
    // message:
    //   'The server has encountered an error, our engineers are working on this, please try again later',
  },
  {
    code: 503,
    title: '503_generic_error_title',
    message: '503_generic_error',
    // title: 'Service Unavailable',
    // message: 'The server is currently unavailable, please try again later',
  },
  {
    code: 504,
    title: '504_generic_error_title',
    message: '504_generic_error',
    // title: 'Gateway Timeout',
    // message: 'The server is currently unavailable, please try again later',
  },
];

class CaseInsensitiveMap<T> extends Map<string, T> {
  get(key: string) {
    return super.get(key.toLowerCase());
  }

  has(key: string) {
    return super.has(key.toLowerCase());
  }

  set(key: string, value: T) {
    return super.set(key.toLowerCase(), value);
  }
}

export const stateAbbreviations = new CaseInsensitiveMap([
  ['Alabama', 'AL'],
  ['Alaska', 'AK'],
  ['Arizona', 'AZ'],
  ['Arkansas', 'AR'],
  ['California', 'CA'],
  ['Colorado', 'CO'],
  ['Connecticut', 'CT'],
  ['Delaware', 'DE'],
  ['District Of Columbia', 'DC'],
  ['Florida', 'FL'],
  ['Georgia', 'GA'],
  ['Hawaii', 'HI'],
  ['Idaho', 'ID'],
  ['Illinois', 'IL'],
  ['Indiana', 'IN'],
  ['Iowa', 'IA'],
  ['Kansas', 'KS'],
  ['Kentucky', 'KY'],
  ['Louisiana', 'LA'],
  ['Maine', 'ME'],
  ['Maryland', 'MD'],
  ['Massachusetts', 'MA'],
  ['Michigan', 'MI'],
  ['Minnesota', 'MN'],
  ['Mississippi', 'MS'],
  ['Missouri', 'MO'],
  ['Montana', 'MT'],
  ['Nebraska', 'NE'],
  ['Nevada', 'NV'],
  ['New Hampshire', 'NH'],
  ['New Jersey', 'NJ'],
  ['New Mexico', 'NM'],
  ['New York', 'NY'],
  ['North Carolina', 'NC'],
  ['North Dakota', 'ND'],
  ['Ohio', 'OH'],
  ['Oklahoma', 'OK'],
  ['Oregon', 'OR'],
  ['Pennsylvania', 'PA'],
  ['Rhode Island', 'RI'],
  ['South Carolina', 'SC'],
  ['South Dakota', 'SD'],
  ['Tennessee', 'TN'],
  ['Texas', 'TX'],
  ['Utah', 'UT'],
  ['Vermont', 'VT'],
  ['Virginia', 'VA'],
  ['Washington', 'WA'],
  ['West Virginia', 'WV'],
  ['Wisconsin', 'WI'],
  ['Wyoming', 'WY'],
]);

// export {
//   Attraction as TishmanAttraction,
//   Flow as TishmanFlow,
// } from '../../services/odt';
